<template>
	<div id="modal__splitOrder">
		<BRow align-h="between" class="card_split_container">
			<div v-for="(split, i) in Splits" :key="split.SplitNumber" class="split-card-width">
  			<div class="boarding-card-container">
					<div class="top-info-container">
						<div class="boarding-card width-100">
							<div class="split-remove-container">
								<font-awesome-icon
								class="split-remove"
								icon="minus-circle"
								v-if="i != 0"
								@click="removeSplit(i)"
								/>
							</div>
							<i class="boarding-card__ttl"
								>{{ order.CorporateName }}</i
							>
							<div class="width-50">
								<h6>Trucks Remaining: 
									<b>{{ split.Remaining }}</b>
								</h6>
							</div>
							<div class="width-50">
								<h6>Total on Order: <b>{{ split.Total }}</b></h6>
							</div>
							<div class="width-100"><h6>Returning: {{ split.OffTrucks.length }}</h6></div>
							<VueDraggable 
								v-model="split.OffTrucks" 
								group="reserve"
								@start="drag=true" 
								@end="dropped($event)"
								ghostClass='ghost'
								:id="i"
								class="drag-zone">
								<div v-for="unit in split.OffTrucks" :key="unit" class="width-100">
									<BButton variant="secondary" class="draggable-buttons">{{ unit.split(' - ')[0] }}</BButton>
								</div>
							</VueDraggable>
						</div>
					</div>
				</div>
			</div>
			<div v-if="OriginalRemaining > 0 && OriginalReturning > 1" class="split-card-width">
  			<div class="boarding-card-container">
					<div class="top-info-container">
						<div class="add-split-card width-100">
							<div class="load-more-btn" @click="addSplit()">
								<p class="plus-btn plus-btn-split">+</p>
								<p class="load-more-text add-split-text">Add Split</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</BRow><br>
		<BRow align-h="between" class="width-100">
			<BCol cols="auto">
				<BButton variant="outline-secondary float-start" @click="$emit('closeModal')">Cancel</BButton>
			</BCol>
			<BCol cols="auto">
				<BSpinner v-if="Splitting">Splitting...</BSpinner>
				<BButton v-else variant="outline-primary float-end" @click="confirmSplit">Split</BButton>
			</BCol>
		</BRow>
		<BRow v-if="splitError">
			<h6 class="red">{{ splitError }}</h6>
		</BRow>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import constants from '@/assets/constants';
import { VueDraggable } from 'vue-draggable-plus';

export default {
  props: ['order'],
	components: {
		VueDraggable,
	},
	name: 'splitOffModal',
	data() {
		return {
			Splits: [{
				SplitNumber: 0,
				Remaining: this.order.TrucksRemaining,
				Total: this.order.NumTrucksReturning,
        		OffTrucks: this.order.Trucks.split(',')
			}],
			OriginalRemaining: this.order.TrucksRemaining,
			OriginalReturning: this.order.NumTrucksReturning,
			Splitting: false,
			splitError: '',
			TruckType: '',
		};
	},
	computed: mapGetters(['getCurrentNoteOrder']),
	created() {
	},
	methods: {
		...mapActions(['closeModal', 'fetchAllOrders']),
		addSplit() {
			let lastOffRent = [];
			let remainSub = false;
			for (let i = 0; i < this.Splits.length; i++) {
				if (this.Splits[i].Remaining > 1) {
					this.Splits[i].Total = this.Splits[i].Total - 1;
					if (this.Splits[i].OffTrucks.length > 1 && 
						(this.Splits[i].Remaining < this.Splits[i].OffTrucks.length ||
						this.Splits[i].OffTrucks.length > this.Splits[i].Total)
					) {
						if (this.Splits[i].OffTrucks[this.Splits[i].OffTrucks.length - 1].split(' - ')[2] == 'unassigned') {
							this.Splits[i].Remaining = this.Splits[i].Remaining - 1;
							remainSub = true;
						}  
						lastOffRent.push(this.Splits[i].OffTrucks.pop());
					}
					if (this.Splits[i].OffTrucks.length == 0) {
						this.Splits[i].Remaining--;
						remainSub = true;
					}
					// Don't keep removing remaining after first one found available
					break;
				} else {
					this.Splits[i].Total = this.Splits[i].Total - 1;
				}
			}
			this.Splits.push({
				SplitNumber: this.Splits[this.Splits.length - 1].SplitNumber + 1,
				Remaining: remainSub ? 1 : 0,
				Total: 1,
				OffTrucks: lastOffRent
			});
			this.OriginalRemaining--;
			this.OriginalReturning--;
		},
		removeSplit(i) {
			this.Splits[0].Remaining += this.Splits[i].Remaining;
			this.Splits[0].Total += this.Splits[i].Total;
			this.Splits[0].OffTrucks = this.Splits[0].OffTrucks.concat(this.Splits[i].OffTrucks);
			this.Splits.splice(i, 1);
			this.OriginalRemaining++;
			this.OriginalReturning++;
		},
		async confirmSplit() {
			this.Splitting = true;
			// console.log('originalRemaining: ', this.order);
      		// console.log('Splits: ', this.Splits);
			for (let i = 0; i < this.Splits.length; i++) {
				if (this.Splits[i].Remaining != this.Splits[i].Total && this.OriginalRemaining == this.OriginalReturning) {
					this.Splitting = false;
					this.splitError = 'Please make sure Trucks Remaining matches Total on Order for all split off rents.';
          			setTimeout(() => (this.splitError = ''), 10000);
					return;
				} else if (this.Splits[i].Total == 0 || this.Splits[i].Reservations == 0) {
					this.Splitting = false;
					this.splitError = 'Cannot split off rent with 0 Trucks on it.';
          			setTimeout(() => (this.splitError = ''), 10000);
					return;
				} else if (this.Splits[i].OffTrucks.length > this.Splits[i].Remaining && this.OriginalRemaining == this.OriginalReturning) {
					// console.log('off rent length: ', this.Splits[i].OffTrucks.length);
					// console.log('remaining: ', this.Splits[i].Remaining);
					this.Splitting = false;
					this.splitError = 'Cannot split off rent with more units than remaining trucks on the off rent.';
          			setTimeout(() => (this.splitError = ''), 10000);
					return;
				}
			}
			if (this.Splits.length > 1) {
				await axios
				.put(`${constants.BASE_URL}/api/split-off-rent`, {
					Splits: this.Splits,
					OgOrder: this.order,
				})
        		.then(res => {
					this.Splitting = false;
					this.$socket.emit('transportCardsRefresh');
					this.$socket.emit('offBoardingCardsRefresh');
          			this.$socket.emit('arOffRentCardsRefresh')
					this.$emit('closeModal');
				})
        		.catch(err => {
					console.log(err);
					this.splitError = 'Unable to complete split.';
          			setTimeout(() => (this.splitError = ''), 6000);
        		});
			} else {
				this.splitError = 'Must have at least one split.';
				this.Splitting = false;
				setTimeout(() => (this.splitError = ''), 6000);
			}
		},
		dropped(evt) {
			this.drag = false;
			let movedTruck = this.Splits[evt.to.id].OffTrucks[evt.newIndex];
			if (this.Splits[evt.from.id].OffTrucks.length < this.Splits[evt.from.id].Total) {
				this.Splits[evt.from.id].Total--;
				this.Splits[evt.to.id].Total++;
			}
			if (this.Splits[evt.to.id].OffTrucks.length > this.Splits[evt.to.id].Remaining) {
				if (
				// 	(this.Splits[evt.from.id].Remaining > 1 || this.Splits[evt.from.id].OffTrucks.length == 0) && 
				// this.Splits[evt.to.id].OffTrucks.length > this.Splits[evt.to.id].Remaining &&
				movedTruck.split(' - ')[2] == 'unassigned') {
					this.Splits[evt.to.id].Remaining++;
					this.Splits[evt.from.id].Remaining--;
					// if (this.Splits[evt.to.id].Remaining > this.Splits[evt.to.id].Total) {
					// }
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/index';

#modal__splitOrder {
	min-width: 100%;
	min-height: 100%;
	@include F($d: column);
}
.card_split_container {
  width: 90%;
  min-height: 65vh;
  @include F($j: flex-start);
  flex-wrap: wrap;
  position: relative;
}
.split-card-width {
	width: 45%;
}
.boarding-card-container {
  position: relative;
}
.boarding-card {
	background-color: var(--jumbotron-bg-color);
}
.width-50 {
	width: 50%;
}
.drag-zone {
	min-width: 200px;
	min-height: 200px;
	max-height: 380px;
	border: 1px solid lightgray;
	overflow-y: scroll;
}
.red {
	color: red;
}
.split-remove {
	color: red;
	margin-right: 10px;
	cursor: pointer;
}
.split-remove-container {
	width: 100%;
	position: absolute;
	text-align: right;
}
.subtract-count {
	font-size: .9rem;
	margin-right: 4px;
	margin-left: 2px;
	cursor: pointer;
}
.add-count {
	font-size: .9rem;
	margin-right: 2px;
	margin-left: 4px;
	cursor: pointer;
}
.draggable-buttons {
	margin: 5px;
}
::-webkit-scrollbar{
	width: 5px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d1d1d1;
  border-radius: 20px;
  border: 6px solid transparent;
}

::-webkit-scrollbar-thumb:hover{
	background-color: #909090;
}
</style>
  